import React from "react";
import SaleBadgeAndPricing from "~/common/SaleBadgeAndPricing";
import GoogleViewPrice from "./GoogleViewPrice";
import StandardPrice from "./StandardPrice";

interface Props {
  unitOfMeasure: string;
  regularPrice: number;
  p1Price: number;
  showCrossoutPrice: boolean;
  divideByUnit?: string;
  divideQuantity?: number;
  isGoogleView: boolean;
  minimumBuy: number;
  mustBuy: number;
  divideByUnitCssClass: string;
}

const PlusRegularPricing = ({
  unitOfMeasure,
  regularPrice,
  p1Price,
  showCrossoutPrice,
  divideByUnit,
  divideQuantity,
  isGoogleView,
  minimumBuy,
  mustBuy,
  divideByUnitCssClass,
}: Props) => (
  <>
    {showCrossoutPrice ? (
      <>
        {isGoogleView ? (
          <div className="pt-6" />
        ) : (
          <SaleBadgeAndPricing
            salePricingClassNames="p-0 mb-0 py-1 flex items-center text-sm text-gray-800 font-normal"
            dataTestId="crossout-price"
            saleBadgeExtraClassNames="px-1 mr-1"
            price={p1Price}
            salePrice={regularPrice}
            unitOfMeasure={unitOfMeasure}
            enableSalePriceScreenReaderText
          />
        )}
      </>
    ) : (
      <span className="price__label text-sm">Regularly</span>
    )}
    {isGoogleView ? (
      <GoogleViewPrice
        price={regularPrice}
        unitOfMeasure={unitOfMeasure}
        showCreditKey={false}
        divideByUnit={divideByUnit}
        divideQuantity={divideQuantity}
        divideByUnitCssClass={divideByUnitCssClass}
        minimumBuy={minimumBuy}
        mustBuy={mustBuy}
      />
    ) : (
      <StandardPrice
        price={regularPrice}
        unitOfMeasure={unitOfMeasure}
        showCreditKey={false}
        divideByUnit={divideByUnit}
        divideQuantity={divideQuantity}
        divideByUnitCssClass={divideByUnitCssClass}
      />
    )}
  </>
);

export default PlusRegularPricing;
